import { render, staticRenderFns } from "./AutosaveController.vue?vue&type=template&id=c93a627a&scoped=true"
import script from "./AutosaveController.vue?vue&type=script&lang=js"
export * from "./AutosaveController.vue?vue&type=script&lang=js"
import style0 from "./AutosaveController.vue?vue&type=style&index=0&id=c93a627a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93a627a",
  null
  
)

export default component.exports